import React from 'react'
import { cerTopic } from '../../../../../constants/constants'

import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../stores/manageProject/useManageProjectAction'

import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'

import checkPermission from '../../../../../utilities/checkPermission'
import useLoading from '../../../../../control/loading/useLoading'
import useWebService from '../../../../../services/web/useWebService'
import { SignREC1Type } from './signREC1'
import { DialogType } from '../../../../../control/dialog/dialog'
import authenStore from '../../../../../stores/authen/authenStore'
import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'
import useTranslate from '../../../../../i18n/useTranslate'
import SecretCodeForm from '../../../shareUI/secretCodeForm/secretCodeForm'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../router/routesConfig'

// --- Contants --- //
import constUserGroup from '../../../../../constants/userGroup'
import { encryption } from '../../../../../utilities/encryption'
import { certificateInfoType } from '../../../../../services/web/types/responseWebServiceTypes'
type CerDialogType = Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>
const useSignREC1 = (props: SignREC1Type) => {
    const translate = useTranslate()
    const { callbackSaveComplete } = props
    const checkPermissionHook = checkPermission()
    const loadingHook = useLoading()
    const callWebService = useWebService()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectStore = useManageProjectStore()
    const { projectData } = manageProjectStore
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const history = useHistory()
    const [isNotShowSign, setIsNotShowSign] = React.useState<boolean>(false)

    const statusAfterClose = React.useRef<string>('save')

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const { tabSelected } = appFolderAndTabStore
    const profileStore = authenStore()
    const { profile } = profileStore

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [initialUploadFileCer, setInitialUploadFileCer] = React.useState<any>()
    const [configDialog, setConfigDialog] = React.useState<CerDialogType>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const [initialUploadFileCerSign, setInitialUploadFileCerSign] = React.useState<any>()

    React.useEffect(() => {
        createInitialUploadFileCer()
    }, [])
    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    const createInitialUploadFileCer = async () => {
        const uploadFileinitCer = cerTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        if (projectData) {
            const submittedID = projectData.submittedID
            const projectID = projectData.projectID
            loadingHook.loadingOpen()
            const data = await callWebService.getSignCertificate(projectID, submittedID)
            await chkBtnSing(projectID, submittedID)

            loadingHook.loadingClose()
            if (data.status === 1) {
                const certificateInfo = data?.result.certificateInfo
                uploadFileinitCer.forEach((itm: any) => {
                    if (itm.uploadFileObj.documentTopicID === 1) {
                        let objUploadEn = {
                            filename: certificateInfo.cer_en.name ? certificateInfo.cer_en.name : '',
                            path: certificateInfo.cer_en.url ? certificateInfo.cer_en.url : '',
                        }
                        itm.uploadFileObj.fileList.push(objUploadEn)
                    } else if (itm.uploadFileObj.documentTopicID === 0) {
                        let objUploadTH = {
                            filename: certificateInfo.cer_th.name ? certificateInfo.cer_th.name : '',
                            path: certificateInfo.cer_th.url ? certificateInfo.cer_th.url : '',
                        }
                        itm.uploadFileObj.fileList.push(objUploadTH)
                    }
                })

                const initialFileValue = createInitialFile(certificateInfo)
                setInitialUploadFileCerSign(initialFileValue)
            }
        }
        setInitialUploadFileCer(uploadFileinitCer)
    }

    const createInitialFile = (certificateInfo: certificateInfoType) => {
        const uploadFileinitCer = cerTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })

        // const certificateInfo = result.certificateInfo
        uploadFileinitCer.forEach((itm: any) => {
            if (itm.uploadFileObj.documentTopicID === 1) {
                if (certificateInfo?.certificateSignFileName_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: certificateInfo?.certificateSignFileName_en,
                        filename: certificateInfo?.certificateSignFileName_en,
                        fileID: certificateInfo?.certificateSignFileName_en,
                        path: certificateInfo?.cerSign_en,
                    }

                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            } else if (itm.uploadFileObj.documentTopicID === 0) {
                if (certificateInfo?.certificateSignFileName_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: certificateInfo?.certificateSignFileName_th,
                        filename: certificateInfo?.certificateSignFileName_th,
                        fileID: certificateInfo?.certificateSignFileName_th,
                        path: certificateInfo?.cerSign_th,
                    }

                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            }
        })
        return uploadFileinitCer
        // setInitialUploadFileCer(uploadFileinitCer)
    }

    const getCerTopic = () => {
        let myCerTopic = cerTopic

        if (!projectData?.isLanguageEN) {
            //ตัดภาษาอังกฤษออก
            myCerTopic = cerTopic.filter((itm) => itm.id !== 1)
        }
        if (!projectData?.isLanguageTH) {
            //ตัดภาษาไทยออก
            myCerTopic = cerTopic.filter((itm) => itm.id !== 0)
        }
        return myCerTopic
    }
    const handleDirtyChange = (props: { dirty: boolean }) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }
    const handleSubmitForm = async (val: any) => {
        const signCertificateRequest: REQServiceType.SignCertificateType = {
            projectID: projectData?.projectID || null,
            signUserID: profileStore.profile.userId,
            submittedID: projectData?.submittedID || null,
            isSignBehalfPresident: false,
            isSignBehalfSecretary: false,
            signUserPinCode: null,
        }
        if (val.saveType === 'SAVE') {
            setConfigDialog({
                title: translate.get('LABEL.SECRET_PASSWORD'),
                content: React.createElement(SecretCodeForm, {
                    onClickClose: () => {
                        dialogRef.current?.closeDialog()
                    },
                    onClickSave: (val: any) => {
                        handleSubmitSecretCode({
                            ...signCertificateRequest,
                            signUserPinCode: encryption(val.password),
                        })
                    },
                }),
                type: '',
            })
            dialogRef.current?.openDialog()
        }
    }
    const handleSubmitSecretCode = async (paramForSave: any) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        const res = await callWebService.signCertificate(paramForSave)
        if (callbackSaveComplete) {
            if (res && res.status) {
                callbackSaveComplete(res.status, false)
            }
        }
        loadingHook.loadingClose()
        // await conditionDialog(res?.status)
    }
    // const conditionDialog = (status: number) => {
    //     if (status === 1) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.NOTIFICATION'),
    //             content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
    //             type: 'alert-message',
    //             onAfterClose: handleAfterClose,
    //         })
    //         dialogRef.current?.openDialog()
    //     } else if (status === -2) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.WARNING'),
    //             content: translate.get('ALERT.CONTENT.SECRET_PASSWORD_INCORRECT'),
    //             type: 'alert-message',
    //         })
    //         dialogRef.current?.openDialog()
    //     } else {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.ERROR'),
    //             content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
    //             type: 'alert-message',
    //         })
    //         dialogRef.current?.openDialog()
    //     }
    // }
    // const handleAfterClose = () => {
    //     const { userGroupId } = profile
    //     if (statusAfterClose.current === 'save') {
    //         switch (userGroupId) {
    //             case userGroup.presidentIRB1.groupId:
    //             case userGroup.secretaryIRB1.groupId:
    //             case userGroup.presidentIRB2.groupId:
    //             case userGroup.secretaryIRB2.groupId:
    //             case userGroup.vicePresident.groupId:
    //                 if (
    //                     tabSelected.id === menuTab.tab2Chairman.id ||
    //                     tabSelected.id === menuTab.tab6Chairman.id ||
    //                     tabSelected.id === menuTab.tab9.id
    //                 ) {
    //                     history.push(RoutePath.manageProject)
    //                 } else {
    //                     setDefaultPage()
    //                 }
    //                 break
    //             case userGroup.committee.groupId:
    //                 if (tabSelected.id === menuTab.tab5Commitee.id) {
    //                     history.push(RoutePath.manageProject)
    //                 }
    //                 break

    //             default:
    //                 setDefaultPage()
    //                 break
    //         }
    //     } else {
    //         setDefaultPage()
    //     }
    // }
    // const setDefaultPage = () => {
    //     setConfigDialog({}) //clear function dialog
    //     // loadLatestFolder()
    //     appFolderAndTabAction.resetTabDirty()
    // }

    const chkBtnSing = async (projectID: number, submittedID: number) => {
        if (projectID && submittedID) {
            const { result, status } = await callWebService.getSignCertificate(projectID, submittedID)

            if (status === 1) {
                if (
                    profile.userGroupId === constUserGroup.president ||
                    profile.userGroupId === constUserGroup.reviewer
                ) {
                    setIsNotShowSign(result.isSignBeHalfPresident)
                } else if (profile.userGroupId === constUserGroup.secretary) {
                    setIsNotShowSign(result.isSignBeHalfSecretary)
                }
            }
        }
    }
    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }
    return {
        onRefDialog,
        configDialog,

        isViewMode,
        isNotShowSign,

        initialValues,
        certificateTopicList: getCerTopic(),
        initialUploadFileCer,
        initialUploadFileCerSign,
        projectData,
        handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        onClickBackToSearch: handleClickBackToSearch,
    }
}
export default useSignREC1
